// removed by extract-text-webpack-plugin
module.exports = {"brokerWrap":"_1mNMsRR-oJFPQFnFmPOaXq","topWrap":"j3tbSc6DhTDx7KxODvvF7","bgCover":"_3HO73SaU7reo-4mPhs750F","container":"_2Uu0QHuyEkBgHhJPNkjmKs","logo":"_1Kzzcw7ATduY7MLnEPM2Da","content":"zFRlwy8STz8wyyJnDFJZR","title":"_3JzrizOpufvEsPqLtsF3AS","infoMessage":"XkVL6SkxN7wcfXRWioXAF","description":"_1PGSq5f7n1ENc75GsUUCTd","descriptionTitle":"_3PG7xvYu9_PylarFuGtXnN","listBlock":"_1yAfJbZXPK9vvs4IzFm4Op"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/BrokerCommunityContainer/BrokerCommunityContainer.scss
// module id = 1811
// module chunks = 0